import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';

const ActivityTitle = styled.div`
  ${Typography.body_lg_semibold}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const ItemBlock = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 0.5px solid var(--border-primary);
  padding-left: var(--space-32);
  margin-left: var(--space-13);
  :last-child {
    border-left: none;
  }
`;

const ItemChange = styled.div`
  display: flex;
  gap: var(--space-12);
  margin-left: -46px;
  padding-bottom: var(--space-14);
  ${mobile_xl(css`
    gap: var(--space-10);
  `)}
`;

const SubTitle = styled.h3`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  span {
    ${Typography.body_md}
    color: var(--text-secondary);
  }
`;
const Update = styled.h3`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;
const ActivityContentView = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  padding-top: var(--space-4);
  ${mobile_xl(css`
    padding-top: var(--space-0);
  `)}
`;

const ActivitySubContent = styled.div`
  display: flex;
  gap: var(--space-6);
`;

const SubText = styled.p`
  width: 100%;
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  word-break: break-word;
`;
const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const ActivityView = styled.div`
  :last-child {
    border-left: none;
  }
  min-height: 300px;
`;

const LeftBarView = styled.div`
  display: flex;
  flex-direction: column;
  padding: var(--space-24) var(--space-24) var(--space-0);
  ${mobile_xl(css`
    padding: var(--space-8) var(--space-20) var(--space-0);
  `)}
`;

const Icon = styled.div``;

const Activity = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space-24);
  ${mobile_xl(css`
    margin-bottom: var(--space-96);
  `)}
`;

export {
  Activity,
  ActivityTitle,
  ItemBlock,
  ItemChange,
  SubTitle,
  ActivityContentView,
  ActivitySubContent,
  SubText,
  Text,
  Icon,
  LeftBarView,
  ActivityView,
  Update
};
